import axios from "axios";

export const parklyLogin = async () => {
  try {
    const response = await axios.post(
      `https://new.api.parkly.mn/api/v2/user/admin-login`,
      {
        email: "amar@hubilai.tech",
        password: "ambu123",
      },
    );
    if (response && response.data) return response.data.token;
    else return null;
  } catch (error) {
    console.error("Error CreatePosPayment:", error);
    return null;
  }
};
